import { FIN_CRR_CREDIT_SITUATION_ITEM } from './fin-crr-credit-situation.js'
import { FIN_CRR_DENOUNCED_CHECKS_ITEM } from './fin-crr-denounced-checks.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_CRR_HELP = {
  screenId: 'fin-crr',
  label: 'Riesgo Crediticio',
  navPath: 'Finanzas → Riesgo Crediticio',
  keywords: [
    'riesgo crediticio', 'bcra', 'central de deudores', 'situación crediticia',
    'cheque rechazado', 'cheque denunciado', 'veraz', 'cuit',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Consultá información del BCRA: deudas y cheques rechazados por CUIT, o si un cheque está denunciado por banco y número.',
  sidebarItems: [FIN_CRR_CREDIT_SITUATION_ITEM, FIN_CRR_DENOUNCED_CHECKS_ITEM],
}
